import 'react';

var chevronUri = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2221%22%20height%3D%2211%22%3E%3Cpath%20d%3D%22m.5.5%2010%2010m10-10-10%2010%22%20fill%3D%22none%22%20stroke%3D%22gray%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

export { chevronUri as c };
